// TODO: This entire file could do with a tidy up and re-write to be made reusable for future use easily
var geocoder,
    map,
    categoryMarkers = {},
    categoryList = [],
    mapboxStyle
document.addEventListener('DOMContentLoaded', function () {
    const mapEle = document.getElementById('map')
    var isBranch = mapEle.getAttribute('branch') || false
    var sort = mapEle.getAttribute('sort') || false
    var mapStyle = mapEle.getAttribute('mapStyle') || 'street'
    switch (mapStyle) {
        case 'street':
            mapboxStyle = 'mapbox://styles/mapbox/streets-v12'
            break
        case 'greyscale':
            mapboxStyle = 'mapbox://styles/mapbox/light-v11'
            break
        case 'rapid':
            mapboxStyle = 'mapbox://styles/absolutekarl/clftjfghp005z01mrbg5frx75'
        default:
            mapboxStyle = 'mapbox://styles/absolutekarl/clftjfghp005z01mrbg5frx75'
    }

    if (Boolean(isBranch)) {
        const branch = new URL(document.URL).pathname.split('/').filter(Boolean).pop()
        getData(`/api/map/${branch}?sort=${sort}`)
    } else {
        getData(`/api/map?sort=${sort}`)
    }
})
async function getData(url) {
    const RESP = await fetch(url)
    const DATA = await RESP.json()
    loadMap(DATA)
}
function loadMap(DATA) {
    mapboxgl.accessToken = 'pk.eyJ1Ijoic2FhamlkdW1hcmppIiwiYSI6ImNsYm56YnJkaDA0MTgzb2xjMGI2bm1vN2cifQ.jcOOz9RooFZ5P_WcN2SxCA'
    map = new mapboxgl.Map({
        container: 'map',
        style: mapboxStyle,
        projection: 'equalEarth',
        maxZoom: 16,
        cooperativeGestures: true
    })
    const nav = new mapboxgl.NavigationControl({
        showCompass: false
    })
    map.addControl(nav, 'top-right')
    var mq = window.matchMedia('(min-width: 815px)')
    if (mq.matches) {
        map.setMinZoom(5)
        map.setZoom(6)
    } else {
        map.setMinZoom(4)
        map.setZoom(5)
    }
    const stores = {
        type: 'FeatureCollection',
        features: []
    }
    // create an array to store the coordinates of all the markers
    var coordinates = []
    Object.keys(DATA).forEach(key => {
        var obj = {
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [DATA[key].longitude, DATA[key].latitude]
            },
            properties: {
                visible: true,
                city: DATA[key].city,
                phone: DATA[key].phone,
                address: DATA[key].address,
                name: DATA[key].branchName,
                category: DATA[key].partnerName,
                postalCode: DATA[key].postalCode,
                partnerLogo: DATA[key].partnerLogo,
                partnerColour: DATA[key].partnerColour,
                partnerMarker: DATA[key].partnerMarker,
                partnerWebsite: DATA[key].partnerWebsite,
                openingMon: DATA[key].opening_hours_monday,
                openingTue: DATA[key].opening_hours_tuesday,
                openingWed: DATA[key].opening_hours_wednesday,
                openingThu: DATA[key].opening_hours_thursday,
                openingFri: DATA[key].opening_hours_friday,
                openingSat: DATA[key].opening_hours_saturday,
                openingSun: DATA[key].opening_hours_sunday
            }
        }
        stores.features[key] = obj
        // add the coordinates of the marker to the array
        coordinates.push([DATA[key].longitude, DATA[key].latitude])
    })
    /**
     * Assign a unique id to each store. You'll use this `id`
     * later to associate each point on the map with a listing
     * in the sidebar.
     */
    stores.features.forEach((store, i) => {
        store.properties.id = i
    })
    /**
     * Wait until the map loads to make changes to the map.
     */
    map.on('load', () => {
        map.addSource('places', {
            type: 'geojson',
            data: stores
        })
        const mapEle = document.getElementById('map')
        var hasFilters = mapEle.getAttribute('filtered') || false
        var isBranch = mapEle.getAttribute('branch') || false
        var initialPostcode = mapEle.getAttribute('postcode')
        var forceConsistantMarkerPath = mapEle.getAttribute('forceConsistantMarkerPath') || false
        if (Boolean(isBranch)) {
            initGeocoder()
            populateCategories()
            styleMarkers(forceConsistantMarkerPath)
        } else if (Boolean(hasFilters)) {
            initGeocoder()
            populateCategories()
            initCategoryList()
            styleMarkers(forceConsistantMarkerPath)
        }
        addMarkers()
        calculateBounds()

        if (initialPostcode) {
            filterStoresByPostcode(initialPostcode)
        }
    })
    function filterStoresByPostcode(postcode) {
        // Get the geocoder input element
        const geocoderInput = document.querySelector('.mapboxgl-ctrl-geocoder--input');

        if (!geocoderInput) return;

        // Set the value to the postcode
        geocoderInput.value = postcode;

        // Trigger the input event so Mapbox notices the change
        const inputEvent = new Event('input', { bubbles: true });
        geocoderInput.dispatchEvent(inputEvent);

        // Trigger Enter keydown event to simulate pressing Enter
        const enterEvent = new KeyboardEvent('keydown', {
            bubbles: true,
            cancelable: true,
            key: 'Enter',
            code: 'Enter'
        });
        geocoderInput.dispatchEvent(enterEvent);

        // Wait a short time for the suggestions to render
        setTimeout(() => {
            const firstSuggestion = document.querySelector('.mapboxgl-ctrl-geocoder .suggestions li.active a');
            if (firstSuggestion) {
                // Manually trigger the click event that Mapbox expects
                firstSuggestion.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
                firstSuggestion.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
                firstSuggestion.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
        }, 400);
    }

    function calculateBounds() {
        const bounds = new mapboxgl.LngLatBounds()
        const mapEle = document.getElementById('map')
        var isBranch = mapEle.getAttribute('branch') || false
        stores.features.forEach(feature => {
            if (feature.properties.visible) bounds.extend(feature.geometry.coordinates)
        })
        var mq = window.matchMedia('(min-width: 815px)')
        if (Boolean(isBranch)) {
            if (mq.matches) {
                // Desktop
                map.fitBounds(bounds, {
                    padding: 220,
                    duration: 0
                })
            } else {
                // Mobile
                map.fitBounds(bounds, {
                    padding: 130,
                    duration: 0
                })
            }
        } else {
            if (mq.matches) {
                // Desktop
                map.fitBounds(bounds, {
                    padding: 160,
                    duration: 0
                })
            } else {
                // Mobile
                map.fitBounds(bounds, {
                    padding: 90,
                    duration: 0
                })
            }
        }
    }
    /**
     * Add a marker to the map for every store listing.
     **/
    function addMarkers() {
        // For each feature in the GeoJSON object above:
        for (const marker of stores.features) {
            // Create a div element for the marker.
            const el = document.createElement('div')
            // Assign a unique `id` to the marker.
            el.id = `marker-${marker.properties.id}`
            // Assign the `marker` class to each marker for styling.
            el.className = 'marker'
            // Add category name to marker if it has one
            marker.properties.category
                ? (el.className = `marker ${marker.properties.category.toLowerCase().trim().replaceAll(/\s+/g, '-')}`)
                : (el.className = 'marker')
            /**
             * Create a marker using the div element
             * defined above and add it to the map.
             **/
            new mapboxgl.Marker(el, { offset: [0, -23] }).setLngLat(marker.geometry.coordinates).addTo(map)
            /**
             * Listen to the element and when it is clicked, do three things:
             * 1. Fly to the point
             * 2. Close all other popups and display popup for clicked store
             * 3. Highlight listing in sidebar (and remove highlight for all other listings)
             **/
            const mapEle = document.getElementById('map')
            var hasFilters = mapEle.getAttribute('filtered') || false
            if (Boolean(hasFilters)) {
                el.addEventListener('click', e => {
                    var isOffset = document.documentElement.clientWidth < 992 ? true : false
                    flyToStore(marker, isOffset)
                    createPopUp(marker, isOffset)
                    const activeItem = document.getElementsByClassName('active')
                    e.stopPropagation()
                    if (activeItem[0]) {
                        activeItem[0].classList.remove('active')
                    }
                    const listing = document.getElementById(`listing-${marker.properties.id}`)
                    listing.classList.add('active')
                })
            }
        }
    }
    /**
     * Add a listing for each store to the sidebar.
     **/
    function buildLocationList(stores) {
        for (const store of stores.features) {
            // Add a new listing section to the sidebar.
            const listings = document.getElementById('listings')
            const listing = listings.appendChild(document.createElement('div'))
            // Assign a unique `id` to the listing.
            listing.id = `listing-${store.properties.id}`
            // Assign the `item` class to each listing for styling.
            listing.className = `item ${store.properties.category.toLowerCase().trim().replaceAll(/\s+/g, '-')}`
            // Add the link to the individual listing created above.
            // const link = listing.appendChild(document.createElement('div'))
            // link.className = 'title'
            // link.id = `link-${store.properties.id}`
            // link.innerHTML = `${store.properties.category} - ${store.properties.name}`
            // Add details to the individual listing.
            const details = listing.appendChild(document.createElement('div'))
            details.innerHTML = `<div class="title" id="link-${store.properties.id}">${store.properties.category} - ${store.properties.name}</div><div>${store.properties.address}</div>`
            details.classList.add('inner-details')
            if (store.properties.phone) {
                details.innerHTML += `<div><strong><a href="tel:${store.properties.phone.replaceAll(' ', '')}">${
                    store.properties.phone
                }</a></strong></div>`
            }
            if (store.properties.distance) {
                const roundedDistance = Math.round(store.properties.distance * 100) / 100
                details.innerHTML += `<div class="distance"><strong>${roundedDistance} miles away</strong></div>`
            }
            /**
             * Listen to the element and when it is clicked, do four things:
             * 1. Update the `currentFeature` to the store associated with the clicked link
             * 2. Fly to the point
             * 3. Close all other popups and display popup for clicked store
             * 4. Highlight listing in sidebar (and remove highlight for all other listings)
             **/
            details.addEventListener('click', function (e) {
                e.preventDefault()
                for (const feature of stores.features) {
                    if (this.querySelector('.title').id === `link-${feature.properties.id}`) {
                        var isOffset = document.documentElement.clientWidth < 992 ? true : false
                        flyToStore(feature, isOffset)
                        createPopUp(feature, isOffset)
                    }
                }
                const activeItem = document.getElementsByClassName('active')
                if (activeItem[0]) {
                    activeItem[0].classList.remove('active')
                }
                this.parentNode.classList.add('active')
            })
        }
    }
    /**
     * Use Mapbox GL JS's `flyTo` to move the camera smoothly
     * a given center point.
     **/
    function flyToStore(currentFeature, isOffset = false) {
        isOffset ? (currentFeature.geometry.coordinates[1] = currentFeature.geometry.coordinates[1] - 0.1) : null
        map.flyTo({
            center: currentFeature.geometry.coordinates,
            zoom: 9
        })
    }
    /**
     * Create a Mapbox GL JS `Popup`.
     **/
    function createPopUp(currentFeature, isOffset = false) {
        const popUps = document.getElementsByClassName('mapboxgl-popup')
        if (popUps[0]) popUps[0].remove()
        const c = currentFeature.properties
        // Check if city is already in the address before adding it
        const cityInAddress = c.city && c.address.toLowerCase().includes(c.city.toLowerCase())
        const joinAddress = c.address + (!cityInAddress && c.city ? ', ' + c.city : '') + ', ' + c.postalCode
        const address = joinAddress.replaceAll(',', ',<br />')
        isOffset ? (currentFeature.geometry.coordinates[1] = currentFeature.geometry.coordinates[1] + 0.1) : null
        new mapboxgl.Popup()
            .setLngLat(currentFeature.geometry.coordinates)
            .setHTML(
                `<div class="popup">
                    <div class="popup__title px-4" style="background: ${c.partnerColour}">
                        <h4>${c.category} - ${c.name}</h4>
                    </div>
                    <div class="popup__content row px-4">
                        <div class="popup__left col">
                            <strong>Address</strong>
                            <p class="popup__address">${address}</p>
                            <a class="popup__tel" style="color: ${c.partnerColour}" href="tel:${c.phone.replaceAll(' ', '')}">${c.phone}</a>
                        </div>
                        <div class="popup__middle col">
                            <strong>Opening Hours</strong>
                            <ul>
                                <li>Mon: ${c.openingMon || 'Closed'}</li>
                                <li>Tue: ${c.openingTue || 'Closed'}</li>
                                <li>Wed: ${c.openingWed || 'Closed'}</li>
                                <li>Thu: ${c.openingThu || 'Closed'}</li>
                                <li>Fri: ${c.openingFri || 'Closed'}</li>
                                <li>Sat: ${c.openingSat || 'Closed'}</li>
                                <li>Sun: ${c.openingSun || 'Closed'}</li>
                            </ul>
                        </div>
                        <div class="popup__right col-3 p-0 d-none d-sm-flex">
                            <img class="popup__image" src="${c.partnerLogo}" alt="${c.category}">
                        </div>
                    </div>
                </div>`
            )
            .addTo(map)
    }
    function initGeocoder() {
        const geocoder = new MapboxGeocoder({
            accessToken: mapboxgl.accessToken,
            mapboxgl: mapboxgl,
            marker: true,
            placeholder: 'Enter your postcode',
            bbox: [-7.57216793459, 49.959999905, 1.68153079591, 58.6350001085]
        })
        document.getElementById('geocoder').appendChild(geocoder.onAdd(map))
        buildLocationList(stores)
        /**
         * Listen for when a geocoder result is returned. When one is returned:
         * - Calculate distances
         * - Sort stores by distance
         * - Rebuild the listings
         * - Adjust the map camera
         * - Open a popup for the closest store
         * - Highlight the listing for the closest store.
         */
        geocoder.on('result', event => {
            /* Get the coordinate of the search result */
            const searchResult = event.result.geometry
            /**
             * Calculate distances:
             * For each store, use turf.disance to calculate the distance
             * in miles between the searchResult and the store. Assign the
             * calculated value to a property called `distance`.
             */
            const options = { units: 'miles' }
            for (const store of stores.features) {
                store.properties.distance = turf.distance(searchResult, store.geometry, options)
            }
            /**
             * Sort stores by distance from closest to the `searchResult`
             * to furthest.
             */
            stores.features.sort((a, b) => {
                if (a.properties.distance > b.properties.distance) {
                    return 1
                }
                if (a.properties.distance < b.properties.distance) {
                    return -1
                }
                return 0
            })
            /**
             * Rebuild the listings:
             * Remove the existing listings and build the location
             * list again using the newly sorted stores.
             */
            const listings = document.getElementById('listings')
            while (listings.firstChild) {
                listings.removeChild(listings.firstChild)
            }
            buildLocationList(stores)
            var isOffset = document.documentElement.clientWidth < 992 ? true : false
            createPopUp(stores.features[0], isOffset)
            // Highlight the listing for the closest store.
            const activeListing = document.getElementById(`listing-${stores.features[0].properties.id}`)
            const activeItem = document.getElementsByClassName('active')
            if (activeItem[0]) {
                activeItem[0].classList.remove('active')
            }
            activeListing.classList.add('active')
            flyToStore(stores.features[0], isOffset)
            /**
             * Adjust the map camera:
             * Get a bbox that contains both the geocoder result and
             * the closest store. Fit the bounds to that bbox.
             */
            // const bbox = getBbox(stores, 0, searchResult)
            // map.fitBounds(bbox, {
            //     padding: 250
            // })
        })
    }
    function populateCategories() {
        stores.features.forEach((store, i) => {
            const category = store.properties.category
            if (!categoryList.includes(category)) {
                categoryList.push(category)
                const categorySlug = category.toLowerCase().trim().replaceAll(/\s+/g, '-')
                categoryMarkers[categorySlug] = { image: store.properties.partnerMarker, colour: store.properties.partnerColour }
            }
        })
    }
    function initCategoryList() {
        let visibleCategories = 0 // Declare visibleCategories in higher scope
        const paddingValues = [
            { count: 1, value: 220 },
            { count: 3, value: 190 },
            { count: 5, value: 170 },
            { count: Infinity, value: 160 }
        ]
        // Set up the corresponding toggle button for each marker category.
        for (const id of categoryList) {
            const link = document.createElement('a')
            link.id = id
            link.href = ''
            link.textContent = id
            link.className = 'active'
            // Show or hide markers when the toggle is clicked.
            link.onclick = function (e) {
                const clickedLayer = this.textContent
                const markers = document.getElementsByClassName(clickedLayer.toLowerCase().trim().replaceAll(/\s+/g, '-'))
                const popUps = document.getElementsByClassName('mapboxgl-popup')
                if (popUps[0]) popUps[0].remove()
                e.preventDefault()
                e.stopPropagation()
                if (this.classList.contains('hidden')) {
                    this.classList.add('active')
                    this.classList.remove('hidden')
                    for (let i = 0; i < markers.length; i++) {
                        markers[i].style.display = 'block'
                    }
                    stores.features.forEach((store, i) => {
                        const category = store.properties.category
                        if (category == clickedLayer) {
                            store.properties.visible = true
                        }
                    })
                    // Calculate total number of visible categories
                    visibleCategories = document.querySelectorAll('#menu > a.active').length
                    // Determine padding based on number of visible categories
                    const paddingValue = paddingValues.find(p => visibleCategories <= p.count).value
                    // Calculate bounds for visible markers
                    const bounds = new mapboxgl.LngLatBounds()
                    stores.features.forEach(feature => {
                        if (feature.properties.visible) bounds.extend(feature.geometry.coordinates)
                    })
                    if (bounds.isEmpty()) {
                        // No visible markers, set default center and zoom level
                        map.setCenter([-4.152939, 52.901511])
                        map.setZoom(6)
                    } else {
                        map.fitBounds(bounds, {
                            padding: paddingValue,
                            animate: true,
                            duration: 2000
                        })
                    }
                } else {
                    this.classList.add('hidden')
                    this.classList.remove('active')
                    for (let i = 0; i < markers.length; i++) {
                        markers[i].style.display = 'none'
                    }
                    stores.features.forEach((store, i) => {
                        const category = store.properties.category
                        if (category == clickedLayer) {
                            store.properties.visible = false
                        }
                    })
                    // Calculate bounds for visible markers after a short delay
                    setTimeout(function () {
                        const bounds = new mapboxgl.LngLatBounds()
                        stores.features.forEach(feature => {
                            if (feature.properties.visible) bounds.extend(feature.geometry.coordinates)
                        })
                        // Fit map to visible markers with calculated padding
                        if (bounds.isEmpty()) {
                            // No visible markers, set default center and zoom level
                            map.setCenter([-4.152939, 52.901511])
                            map.setZoom(6)
                        } else {
                            // Calculate total number of visible categories
                            visibleCategories = document.querySelectorAll('#menu > a.active').length

                            // Determine padding based on number of visible categories
                            const paddingValue = paddingValues.find(p => visibleCategories <= p.count).value

                            map.fitBounds(bounds, {
                                padding: paddingValue,
                                animate: true,
                                duration: 2000
                            })
                        }
                    }, 500) // delay for 500ms (adjust as needed)
                }
            }
            const layers = document.getElementById('menu')
            layers.appendChild(link)
        }
        const toggle = document.createElement('p')
        toggle.textContent = 'Hide all'
        toggle.className = 'menu--toggle'
        // For bulk toggle
        toggle.onclick = function (e) {
            var selector = this.innerHTML == 'Show all' ? '#menu > a.hidden' : '#menu > a.active'
            const categories = document.querySelectorAll(selector)
            for (let i = 0; i < categories.length; i++) {
                categories[i].click()
            }
            this.innerHTML = categories.length > 0 ? 'Show all' : 'Hide all'
            // Calculate bounds for visible markers
            const bounds = new mapboxgl.LngLatBounds()
            stores.features.forEach(feature => {
                if (feature.properties.visible) bounds.extend(feature.geometry.coordinates)
            })
            map.fitBounds(bounds, {
                padding: 220,
                duration: 0
            })
        }
        const layers = document.getElementById('menu')
        layers.appendChild(toggle)
    }
    function styleMarkers(forceConsistantMarkerPath = false) {
        // Set up styling for coloured markers
        var styleTag = document.createElement('style')

        if (forceConsistantMarkerPath) {
            const style = `
                .marker {
                    background-image: url(${forceConsistantMarkerPath})
                }
            `
            styleTag.insertAdjacentHTML('beforeend', style)
            document.head.appendChild(styleTag)
        } else {
            for (const category in categoryMarkers) {
                const markerClass = `.marker.${category}`
                const accentClass = `#listings .item.${category} .inner-details::before`
                const style = `
                    ${markerClass} {
                        background-image: url('${categoryMarkers[category].image}')
                    }
                    ${accentClass} {
                        background: ${categoryMarkers[category].colour}
                    }
                `
                styleTag.insertAdjacentHTML('beforeend', style)
            }
            document.head.appendChild(styleTag)
        }
    }
}
